<template><div><h1 id="bereinigen-einzelbuchungen" tabindex="-1"><a class="header-anchor" href="#bereinigen-einzelbuchungen"><span>Bereinigen Einzelbuchungen</span></a></h1>
<p>Bereinigen Einzelbuchungen — Löschen von alten Einzelbuchunegn</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Funktion löscht alte Einzelbuchungen. Bei Bedarf können die zu löschenden Buchungen vorgängig exportiert (archiviert) werden.</p>
<div class="hint-container warning">
<p class="hint-container-title">Achtung</p>
<p>Die Buchungen werden gelöscht und können ohne erheblichen technischen Aufwand nicht wieder in funtrade importiert werden!</p>
</div>
<p>Pfad: <code v-pre>Buchhaltung → Datenpflege → Einzelbuchungen bereinigen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Job-Datum</dt>
<dd>
<p>Jobdatum</p>
</dd>
<dt>Lauf-Nr.</dt>
<dd>
<p>Laufnummer des Jobs (bei mehreren Jobs innerhalb eines Datums); wird vom System automatisch vergeben</p>
</dd>
<dt>Periode</dt>
<dd>
<p>Jüngstes, zu berücksichtigendes Belegdatum; nur Belege mit Datum &lt;= [Periode] werden überprüft, ob sie zu bereinigen sind</p>
</dd>
<dt>bis Journal-Nr</dt>
<dd>
<p>Alle Daten mit Journalnummer kleiner oder gleich diesem Eintrag werden gelöscht</p>
</dd>
<dt>Sicherung</dt>
<dd>
<p>Pfad und Dateiname der History-Datei (zur elektronischen Archivierung)</p>
</dd>
<dt>Anzahl EB</dt>
<dd>
<p>Anzahl archivierte Einzelbuchungen</p>
</dd>
<dt>Anzahl Fakturen</dt>
<dd>
<p>Anzahl Fakturen, welche archiviert wurden</p>
</dd>
<dt>Status</dt>
<dd>
<p>Status der Archivierung</p>
</dd>
<dd>
<p>1 = erfasst, noch nicht verarbeitet</p>
</dd>
<dd>
<p>2 = Aufbereitung angefangen bzw. abgebrochen</p>
</dd>
<dd>
<p>X = abgeschlossen</p>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="bereinigen" tabindex="-1"><a class="header-anchor" href="#bereinigen"><span>Bereinigen</span></a></h3>
<p>Startet nach Eingabe von Job-Datum und Lauf-Nr. die Bereinigung</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


